import { ll } from "../../core/ll";
import { emptyFn } from "../../core/util";
import { buildDataBindSyntax } from "../buildDataBindSyntax";
import K_PaneLabelLink from "../templates/K_PaneLabelLink";
import { ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface PaneLabelLinkOptions extends ComponentOptions {
    title?: string;
    label?: string;
    hcLabel?: string;
    bsc?: string;
    labelBsc?: string;
    inputBsc?: string;
    dataBind?: string;
    linkText?: string;
    bindLabel?: string;
    onClick?: () => void;
    clearable?: boolean;
    href?: string;
    cf?: boolean;
    hideSS?: boolean;
}

export class PaneLabelLink extends TemplateComponent {

    options: PaneLabelLinkOptions;

    constructor(options: PaneLabelLinkOptions) {
        super(K_PaneLabelLink, options);
    }

    preRender() {
        const options = this.options;

        options.title = options.label || null;
        options.containerClasses = options.containerClasses || "";
        options.bsc = options.bsc || "col-lg-3 col-md-4 col-xs-6";
        options.labelBsc = options.labelBsc || "col-xs-5";
        options.inputBsc = options.inputBsc || "col-xs-7  signature-pane-field-input";
        options.bindValue = buildDataBindSyntax(options.bindValue, options.dataBind || "signature");
        options.linkText = options.linkText ? ll(options.linkText) : "---";
        options.bindLabel = options.bindLabel ? buildDataBindSyntax(options.bindLabel, "label") : "";
        options.onClick = options.onClick || emptyFn;
    }

    create() {
        var me = this;
        var link = $("#" + me.id);

        link.tie("click", function () {
            me.options.onClick();
        });

    }
}
